import * as Analysis from './analysis/Analysis.selectors';
import * as MonitoredDocument from './monitoredDocument/MonitoredDocument.selectors';
import * as MonitoredDocumentChanges from './monitoredDocument/MonitoredDocumentChanges.selectors';
import * as MonitoredDocumentCompare from './monitoredDocument/MonitoredDocumentCompare.selectors';
import * as MonitoredDocumentMarkdown from './monitoredDocument/MonitoredDocumentMarkdown.selectors';
import * as MonitoredDocumentVersion from './monitoredDocument/MonitoredDocumentVersion.selectors';
import * as MonitoredDocumentVersions from './monitoredDocument/MonitoredDocumentVersions.selectors';

export default {
    MonitoredDocumentChanges,
    MonitoredDocument,
    MonitoredDocumentVersions,
    MonitoredDocumentVersion,
    MonitoredDocumentMarkdown,
    MonitoredDocumentCompare,
    Analysis,
};
